import { useContext } from 'react'
import { BrowserRouter, Navigate, Routes, Route, useLocation } from 'react-router-dom'
import './App.css'
import Header from './Components/Header/Header'
import Footer from './Components/Footer/Footer'
import Homepage from './Pages/Homepage/Homepage'
import Auth from './Pages/Auth/Auth'
import EventsPage from './Pages/EventsPage/EventsPage'
import AdminContextProvider, { AdminContext } from './Context/AdminContext'
import ProductsPage from './Pages/ProductsPage/ProductsPage'
import Cart from './Pages/Cart/Cart'
import ProfilePage from './Pages/ProfilePage/ProfilePage'
import ScrollToTop from './Components/ScrollToTop/ScrollToTop'
import AdminPage from './Pages/AdminPage/AdminPage'
import CateringPage from './Pages/CateringPage/CateringPage'

function ProtectedCart() {
  const { user, authLoading } = useContext(AdminContext);
  if (authLoading) return <div className='route-loading'>Preparing your cart…</div>;
  return user ? <Cart /> : <Navigate to='/auth' replace state={{ returnTo: '/cart' }} />;
}

function AppRoutes() {
  const location = useLocation();
  const isAdminRoute = location.pathname === '/admin';
  const isStorefrontRoute = location.pathname === '/shop' || location.pathname === '/shop/' || location.pathname === '/cart' || location.pathname === '/cart/';

  return (
    <>
      <ScrollToTop />
      {!isAdminRoute ? <Header /> : null}
      <Routes>
        <Route path='/' element={<Homepage />} />
        <Route path='/auth' element={<Auth />} />
        <Route path='/events' element={<EventsPage />} />
        <Route path='/catering' element={<CateringPage />} />
        <Route path='/shop' element={<ProductsPage />} />
        <Route path='/cart' element={<ProtectedCart />} />
        <Route path='/profile' element={<ProfilePage />} />
        <Route path='/admin' element={<AdminPage />} />
        <Route path='*' element={<Homepage />} />
      </Routes>
      {!isAdminRoute ? <Footer variant={isStorefrontRoute ? 'storefront' : 'default'} /> : null}
    </>
  );
}

function App() {

  return (
    <BrowserRouter>
      <AdminContextProvider>
        <AppRoutes />
      </AdminContextProvider>
    </BrowserRouter>
  )
}

export default App
